import { render, staticRenderFns } from "./ChangeLogAttachments.vue?vue&type=template&id=539464c6&scoped=true"
import script from "./ChangeLogAttachments.vue?vue&type=script&lang=js"
export * from "./ChangeLogAttachments.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogAttachments.vue?vue&type=style&index=0&id=539464c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539464c6",
  null
  
)

export default component.exports